import { z } from 'zod';

/** Blank clears the threshold; otherwise a whole number of units. */
export const reorderPointSchema = z.object({
  // Output (a number or null) must stay assignable to the input for react-hook-form's Control type.
  reorderPoint: z
    .union([z.string(), z.number(), z.null()])
    .transform((v) => (v === null ? '' : String(v).trim()))
    .refine((v) => v === '' || /^\d+$/.test(v), {
      error: 'inventory:reorderPoint.validation.whole',
    })
    .transform((v) => (v === '' ? null : Number(v)))
    .refine((v) => v === null || v <= 1_000_000, {
      error: 'inventory:reorderPoint.validation.range',
    }),
});

export type ReorderPointFormInput = z.input<typeof reorderPointSchema>;
export type ReorderPointFormOutput = z.output<typeof reorderPointSchema>;
